export const FETCH_ALL_CUSTOMER_SUCCESS = "FETCH_ALL_CUSTOMER_SUCCESS";
export const FETCH_ALL_CUSTOMER_ERROR = "FETCH_ALL_CUSTOMER_ERROR";

